<template>
  <div class="col-xs-12">
    <vuetable
      ref="vuetable"
      :api-url="this.apiEndpoint"
      :http-options="computed_headers"
      :fields="fields"
      :css="css.table"
      :sort-order="sortOrder"
      :per-page="perPage"
      pagination-path=""
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="dataHasLoaded = false"
      @vuetable:load-success="dataHasLoaded = true"
      @vuetable:load-error="dataHasLoaded = true"
    >
      <template slot="company_name" slot-scope="props">
        <router-link :to="{ path: '/reports/' + props.rowData.report_id }">
          <div class="company-title">
            {{ props.rowData.company_name }}
          </div>
        </router-link>
        <div class="user-client-title">
          <div>{{ props.rowData.user_email }}</div>
          <div>{{ props.rowData.client_name }}</div>
        </div>
      </template>

      <template slot="created_at" slot-scope="props">
        {{ formatDate(props.rowData.created_at) }}
      </template>

      <template slot="options" slot-scope="props">
        <router-link :to="{ path: '/reports/' + props.rowData.report_id }">
          <a role="button" class="btn btn-viewReport btn-xs">View report ></a>
        </router-link>
      </template>
    </vuetable>

    <div class="vuetable-pagination">
      <vuetable-pagination-info
        ref="paginationInfo"
        info-class="pagination-info"
      ></vuetable-pagination-info>
      <vuetable-pagination-bootstrap
        ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination-bootstrap>
    </div>
  </div>
</template>

<script>
import Vuetable from 'vuetable-2';
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
import { mapGetters } from 'vuex';
import VuetablePaginationBootstrap from '@/components/helpers/VuetablePaginationBootstrap';
import { AppConfig } from '@/config/config';
import GenericTableMixin from '@/components/helpers/GenericTableMixin';
import tableMixin from '@/components/reports/reportsindex/TableMixin';

export default {
  mixins: [GenericTableMixin, tableMixin],
  components: {
    Vuetable,
    VuetablePaginationBootstrap,
    VuetablePaginationInfo,
  },
  data() {
    return {
      reportId: 0,
      percent: 0,
      apiEndpoint: `${AppConfig.baseUrl}/v1/reports`,
      perPage: 10,
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['current_user']),
    computed_headers() {
      return {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      };
    },
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    percentStyle(value) {
      return `width:${value}%`;
    },
  },
};
</script>

<style scoped>
.user-client-title {
  color: #aaa;
  font-size: 75%;
}

.company-title {
  font-size: 120%;
}
</style>
